// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__ES-82","title":"Header_title__3x-Gu","left":"Header_left__3BgNa","clinicName":"Header_clinicName__B9oYR"};